import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

import axios from "axios";
import { getToken, getSession } from "../../Utils/SessionUtils";

const api_url = process.env.REACT_APP_API_BASE_URL_V2;
const config = {
  headers: { Authorization: `Bearer ${getToken()}` },
};

/**
 * get annonces by code
 */
export async function getChequesByCode() {
  try {
    const response = await axios.get(api_url + "cheques/users/" + getSession("code_generated"), config);
    return response;
  } catch (error) {
    console.error(error);
  }
}

/**
 * It deletes an cheques by id.
 * @param id - The id of the cheques to delete.
 * @returns The response object contains the status code, the response body, and the response headers.
 */
export async function deleteChequeById(id) {
  try {
    const response = await axios.delete(api_url + "cheques/" + id, config);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function getChequeById(id) {
  try {
    const response = await axios.get(api_url + "cheques/" + id, config);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function ajouterCheque(date, nom, montant, numero, img) {
  const frmData = new FormData();
  frmData.append("code_generated", getSession("code_generated"));
  frmData.append("date", date);
  frmData.append("numero", numero);
  frmData.append("montant", montant);
  frmData.append("client_code", nom);
  frmData.append("image", img);

  const httpHeaders = {
    "Content-Type": "multipart/form-data",
    Authorization: "Bearer " + getToken(),
  };

  const options = {
    headers: httpHeaders,
  };

  try {
    const response = await axios.post(api_url + "cheques", frmData, options);
    toast.success("Chéque ajoutée");
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      toast.error("error server");
      console.log(error.response.data);
      console.log(error.response.message);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the
      // browser and an instance of
      // http.ClientRequest in node.js
      toast.error("error request");
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error.message);
    }
    console.log(error.config);
    return error;
  }
}

export async function updateChequeById(id, date, nom, montant, numero, img) {
  const frmData = new FormData();
  frmData.append("id", id);
  frmData.append("date", date);
  frmData.append("numero", numero);
  frmData.append("montant", montant);
  frmData.append("nom", nom);
  if (img) {
    frmData.append("image", img);
  }

  const httpHeaders = {
    "Content-Type": "multipart/form-data",
    Authorization: "Bearer " + getToken(),
  };

  const options = {
    headers: httpHeaders,
  };

  try {
    const response = await axios.patch(api_url + "cheques", frmData, options);
    toast.success("Chéque modifié");
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      toast.error("error server");
      console.log(error.response.data);
      console.log(error.response.message);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the
      // browser and an instance of
      // http.ClientRequest in node.js
      toast.error("error request");
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error.message);
    }
    console.log(error.config);
    return error;
  }
}
